module.exports = __webpack_public_path__ + "img/map_vijver.19765db0.png";